/****************************************************
 * Module Name:  clarityProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ClarityProxy {
  static GetAllClarity = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clarity",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllClarityMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clarity/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleClarity = (clarityId, callback) => {
    let params = {
      id: clarityId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/clarity",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckClarityAvailable = (clarity, callback) => {
    let params = {
      clarity: clarity,
    };

    restAPICall(
      Constants.MANAGER_URL + "/clarity/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddClarity = (clarity, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clarity",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(clarity),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateClarity = (clarity, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/clarity",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(clarity),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
